import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { NumberStatistic } from 'src/common/charts';
import { fetchContactsReports } from 'actions/Report/Contact';
import _ from 'lodash';

export default class TotalUniqueContacts extends Component {
  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
    this.state = {
      totalUniqueContacts: -1,
      title: '',
    };
  }

  componentDidMount() {
    this.fetchData(this.props.filters);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const filtersChanged = !_.isEqual(this.props.filters, nextProps.filters);
    const networkChanged = !_.isEqual(this.props.id, nextProps.id);

    if (filtersChanged || networkChanged) {
      this.fetchData(nextProps.filters, nextProps.id);
    }
  }

  fetchData(filters, id = this.props.id) {
    const { scope } = this.props;

    fetchContactsReports(scope, id, 'count', { ...filters })
      .then((response) => {
        this.setState({
          totalUniqueContacts: _.get(response, 'data.total', 0),
          title: _.get(response, 'data.title'),
        });
        this.props.loaded('totalUniqueContacts');
      });
  }

  render() {
    if (this.state.totalUniqueContacts < 0) {
      return null;
    }
    return (
      <NumberStatistic
        data={this.state.totalUniqueContacts}
        title={this.state.title}
        icon="IconUser"
        color="#4A657F"
      />
    );
  }
}

TotalUniqueContacts.propTypes = {
  filters: PropTypes.shape({
    end_date: PropTypes.string,
    network_ids: PropTypes.array,
    start_date: PropTypes.string,
  }),
  loaded: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
};
